import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="w-full min-h-screen bg-white flex items-center justify-center px-8">
      <div className="max-w-7xl w-full">
        {/* Main Content Container */}
        <div className="desktop:flex laptop:flex tablet:flex mobile:flex flex-col items-center justify-center text-center space-y-8">
          {/* Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="desktop:text-8xl laptop:text-7xl tablet:text-6xl mobile:text-5xl font-light text-black tracking-tight"
          >
            test
          </motion.h1>

          {/* Subheading */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="desktop:text-xl laptop:text-xl tablet:text-lg mobile:text-base font-light text-gray-600 max-w-2xl"
          >
            minimalist black and white design with lots of whitespace and thin
            Helvetica font
          </motion.p>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12"
          >
            <Link
              to="/"
              className="desktop:px-12 laptop:px-12 tablet:px-10 mobile:px-8 
                        desktop:py-4 laptop:py-4 tablet:py-3 mobile:py-3
                        border border-black text-black
                        desktop:text-lg laptop:text-lg tablet:text-base mobile:text-sm
                        font-light hover:bg-black hover:text-white transition-colors duration-300"
            >
              Explore More
            </Link>
          </motion.div>

          {/* Minimal Arrow Icon */}
          <motion.svg
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="w-6 h-6 mt-16 animate-bounce"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path d="M12 5v14M5 12l7 7 7-7" />
          </motion.svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
